module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bf1ea1e2b4e425b9004a56839435efac.png";